import React from "react";
import styled from "styled-components";
import { z } from "zod";
import { MediaPromoItem } from "../../../../../blades/MediaPromo/components/MediaItem";
import { SkinId } from "../../../../../skins/types";
import { MediaPromoBackdrop } from "../../../../../blades/MediaPromo/components/Backdrop";
import { Blade } from "../../../../../components/Blade";
import { BetaInviteMediaPromoContent } from "./BetaInviteMediaPromoContent";
import { riotProductSkin } from "../skins/riot-product";
import { BladeContent } from "../../../../../components/BladeContent";
import { mixinSkins } from "../../../../../skins/shared/mixins/themeStyles";
import { MediaPromoBladeSchema, } from "../../../../../schemas/blades/MediaPromo";
import { useBetaHubRouter } from "../../../functional/hooks/useBetaHubRouter";
export const BetaInviteMediaPromoContractSchema = MediaPromoBladeSchema.extend({
    type: z.literal("betaInviteMediaPromo"),
});
const _BetaInviteMediaPromo = ({ backdrop, item, className, ...bladeProps }) => {
    let campaignID = "ERROR";
    if (item?.links?.[0]?.action?.payload && item?.links?.[0]?.action?.type === "weblink") {
        campaignID = item?.links?.[0]?.action?.payload.url;
    }
    const { isLoading, inviteCode } = useBetaHubRouter({ campaignID });
    const code = process.env.STORYBOOK ? "b1885b7a-2a34-42e2-8405-95f70465c6b0" : inviteCode || "";
    if (isLoading) {
        return null;
    }
    return (React.createElement(Blade, { "data-testid": "BetaInviteMediaPromo", className: `${className} ${backdrop ? "backdrop-exist" : "backdrop-not-exist"} ${item?.media ? "layout-image" : "layout-no-image"}`, ...bladeProps },
        React.createElement(BladeContent, { width: "large", className: `blade-content ${item?.media ? "content-image" : "content-no-image"}` },
            backdrop && React.createElement(MediaPromoBackdrop, { ...backdrop }),
            React.createElement("div", { "data-testid": "mediapromoinvite-main-container", className: `main-container ${item?.media ? "w-image" : "wo-image"}` },
                React.createElement("div", { className: "left-container" },
                    React.createElement(BetaInviteMediaPromoContent, { inviteCode: code, ...item })),
                React.createElement("div", { className: "right-container" },
                    React.createElement(MediaPromoItem, { media: item?.media }))))));
};
export const BetaInviteMediaPromo = styled(_BetaInviteMediaPromo) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=BetaInviteMediaPromo.js.map